class PackForm {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-pack-form-element]');
    this.submitBtn = root.querySelector('[data-pack-submit]');
    this.errorEl = root.querySelector('[data-pack-error]');
    this.payloadInput = root.querySelector('[data-pack-components-payload]');

    if (!this.form) return;
    this.bind();
  }

  bind() {
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
  }

  validate() {
    const missing = [];
    const components = this.root.querySelectorAll('.pack-form__component');
    for (const component of components) {
      const radios = component.querySelectorAll('.pack-form__size-input:not(.pack-form__size-input--fixed)');
      if (radios.length === 0) continue;
      const checked = component.querySelector('.pack-form__size-input:checked');
      if (!checked) missing.push(component.dataset.componentLabel);
    }
    return missing;
  }

  collectVariantIds() {
    const items = [];
    const components = this.root.querySelectorAll('.pack-form__component');
    for (const component of components) {
      const fixed = component.querySelector('.pack-form__size-input--fixed');
      if (fixed) {
        const gid = fixed.dataset.variantGid;
        if (gid) items.push({ variantId: gid, quantity: 1 });
        continue;
      }
      const checked = component.querySelector('.pack-form__size-input:checked');
      if (checked) {
        const gid = checked.dataset.variantGid;
        if (gid) items.push({ variantId: gid, quantity: 1 });
      }
    }
    return items;
  }

  showError(msg) {
    if (!this.errorEl) return;
    this.errorEl.textContent = msg;
    this.errorEl.hidden = false;
  }

  clearError() {
    if (!this.errorEl) return;
    this.errorEl.textContent = '';
    this.errorEl.hidden = true;
  }

  setLoading(loading) {
    if (!this.submitBtn) return;
    const text = this.submitBtn.querySelector('.btn__text');
    const loadingEl = this.submitBtn.querySelector('.btn__loading');
    this.submitBtn.disabled = loading;
    if (text) text.style.display = loading ? 'none' : '';
    if (loadingEl) loadingEl.style.display = loading ? '' : 'none';
  }

  async handleSubmit(e) {
    e.preventDefault();
    this.clearError();

    const missing = this.validate();
    if (missing.length > 0) {
      this.showError(`Sélectionne une taille pour : ${missing.join(', ')}`);
      return;
    }

    const items = this.collectVariantIds();
    if (items.length === 0) {
      this.showError('Composition du pack introuvable. Vérifie la configuration.');
      return;
    }

    this.payloadInput.value = JSON.stringify(items);
    this.setLoading(true);

    try {
      const formData = new FormData(this.form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || `HTTP ${res.status}`);
      }

      const added = await res.json();
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: added }));

      if (window.notyf) {
        window.notyf.success('Pack ajouté au panier');
      }
    } catch (err) {
      this.showError(err.message || 'Erreur lors de l\'ajout au panier');
    } finally {
      this.setLoading(false);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pack-form]').forEach((el) => new PackForm(el));
});
